// W5 (Lucas 2026-08-10) — prefixo de origem escrito pelo plugin "ChatWoot App"
// embutido no WAHA, NÃO por nós. A correção definitiva é na imagem do WAHA (que
// é nossa), mas ela não limpa o histórico já gravado — então a tela também
// esconde. O dado no banco não é tocado: nada se perde, e é reversível.
//
// Fica num helper só pra a regex não se multiplicar: o mesmo prefixo aparece na
// bolha, no preview da lista e na notificação.
export const WAHA_SEND_PREFIX = /^\*📱 Enviado (do WhatsApp|via API)\*\s*/;

export const stripWahaSendPrefix = (text = '') =>
  (text || '').replace(WAHA_SEND_PREFIX, '');
